import { Button, getKeyValue } from "@nextui-org/react";
import { Key, useCallback, useState } from "react";
import DownlineList from "./downlinelist";

import {
  ActiveIcon,
  CopyIcon,
  InActiveIcon,
  ViewListIcon,
} from "@/assets/icons/admin";
import { useGetAllReferral } from "@/services/admin.service";
import { toast } from "react-toastify";
import Datatable from "@/components/tables/datatable";

const fields = [
  { label: "Username", value: "userName" },
  { label: "Referral Links", value: "id" },
];

const ReferralList = () => {
  const [isViewingList, setIsViewingList] = useState(false);
  const [editItemId, setEditItemId] = useState("");
  const query = useGetAllReferral;

  const columns = [
    {
      key: "no",
      label: "No",
    },
    {
      key: "userName",
      label: "Username",
    },
    {
      key: "fullName",
      label: "Fullname",
    },
    {
      key: "reflinks",
      label: "Ref.Links",
    },
    {
      key: "totaldownline",
      label: "Total Downline",
    },
    {
      key: "myprofit",
      label: "Total Commission",
    },
    {
      key: "status",
      label: "Status",
    },
    // {
    //   key: "action",
    //   label: "Action",
    // },
  ];

  const handleCopyText = (id: string) => {
    navigator.clipboard
      .writeText(id)
      .then(() => {
        toast.success("Text copied to clipboard");
      })
      .catch((error) => {
        console.error("Error copying text to clipboard:", error);
        toast.error("Error copying text to clipboard");
      });
  };

  const handleViewClick = (itemId: any) => {
    setIsViewingList(true);
    setEditItemId(itemId);
  };

  const handleCancelView = () => {
    setIsViewingList(false);
    setEditItemId("");
  };

  const renderCell = useCallback((data: any[], item: any, columnKey: Key) => {
    switch (columnKey) {
      case "no":
        return (
          <div className="">
            {data.findIndex(
              (row: any) => (row as any)?.id === (item as any)?.id,
            ) + 1}
          </div>
        );
      case "username":
        return (
          <div className="tb-data-blue"> {getKeyValue(item, columnKey)}</div>
        );
      case "fullname":
        return (
          <div className="font-normal"> {getKeyValue(item, columnKey)}</div>
        );

      case "totaldownline":
        return (
          <Button
            onClick={() =>
              getKeyValue(item, columnKey) !== 0
                ? handleViewClick(getKeyValue(item, "id"))
                : toast.error("Data Not found!")
            }
            isIconOnly
            className="transparent-bg h-auto w-auto"
          >
            <div className="tb-data-blue"> {item._count.referredBy || "0"}</div>
          </Button>
        );

      case "reflinks":
        return (
          <div className="items-center font-normal">
            <span className="flex items-center">
              <p>{getKeyValue(item, "id")}</p>
              <Button
                isIconOnly
                onClick={() => handleCopyText(getKeyValue(item, "id"))}
                className="transparent-bg h-6 w-6"
              >
                <CopyIcon />
              </Button>
            </span>
          </div>
        );
      case "action":
        return (
          <div>
            <Button
              onClick={() =>
                getKeyValue(item, columnKey) !== 0
                  ? handleViewClick(item)
                  : toast.error("Data Not found!")
              }
              isIconOnly
              className="transparent-bg h-auto w-auto"
            >
              <ViewListIcon />
            </Button>
          </div>
        );
      case "status":
        return (
          <div className="flex items-center">
            {item?.status === "ACTIVE" ? (
              <span>
                <ActiveIcon />
              </span>
            ) : (
              <span>
                <InActiveIcon />
              </span>
            )}
          </div>
        );
      case "myprofit":
        return (
          <div className="font-normal">
            {`$${item.referredUserPayouts.reduce((total: any, payout: { payoutAmount: any }) => total + payout.payoutAmount, 0)?.toLocaleString()}`}
          </div>
        );
      default:
        return (
          <div className="font-normal">
            {getKeyValue(item, columnKey as string) || "-"}
          </div>
        );
    }
  }, []);

  return (
    <div>
      {isViewingList ? (
        <DownlineList itemId={editItemId} onCancel={handleCancelView} />
      ) : (
        <div>
          <div className="font-ubuntu float-left text-center text-2xl  text-sm font-semibold text-white sm:text-lg">
            <p className="hidden sm:block">Referral Downline</p>
          </div>
          <Datatable
            columns={columns}
            renderCell={renderCell}
            query={query}
            customFilters={[]}
            searchFields={fields}
          />
        </div>
      )}
    </div>
  );
};

export default ReferralList;
